import React from "react";

import { useIntl } from "react-intl";

import Error from "Components/Error";
import * as Radio from "ds/Radio";

import { DeploymentTypeChangeModal } from "./DeploymentTypeChangeModal";
import * as S from "./DeploymentTypeSetting.styles";

export const DEPLOYMENT_TYPES = { automatic: "automatic", manual: "manual" };

type Props = {
  onDeploymentTypeChange: (value: string) => void;
  onChangeDeploymentTypeSave: (e) => void;
  confirmDeploymentTypeChangeModal: boolean;
  closeModal: () => void;
  cancel: () => void;
  deploymentType?: string;
  hasEditPermission?: boolean;
  errors?: {
    message: string;
  };
};

const DeploymentTypeSetting = ({
  onDeploymentTypeChange,
  onChangeDeploymentTypeSave,
  confirmDeploymentTypeChangeModal,
  closeModal,
  cancel,
  errors,
  deploymentType,
  hasEditPermission
}: Props) => {
  const intl = useIntl();

  return (
    <>
      <S.SettingWrapper>
        <S.DeployementSectionLabel>
          {intl.formatMessage({
            id: `environment.settings.explicit_deployment.label`
          })}
        </S.DeployementSectionLabel>
        <Radio.Group
          value={deploymentType}
          onValueChange={onDeploymentTypeChange}
        >
          {Object.values(DEPLOYMENT_TYPES).map(elt => (
            <Radio.Input
              key={`explicit-deployment-${elt}`}
              id={`explicit-deployment-${elt}`}
              value={elt}
              disabled={!hasEditPermission}
              optionDetails={intl.formatMessage({
                id: `environment.settings.explicit_deployment.${elt}.description`
              })}
              label={
                <>
                  <S.DeploymentTypeLabel
                    onClick={() => {
                      onDeploymentTypeChange(elt);
                    }}
                  >
                    {intl.formatMessage({
                      id: `environment.settings.explicit_deployment.${elt}.label`
                    })}
                  </S.DeploymentTypeLabel>
                </>
              }
            ></Radio.Input>
          ))}
        </Radio.Group>
        {errors?.message && (
          <S.ErrorWrapper>
            <Error>{errors?.message}</Error>
          </S.ErrorWrapper>
        )}
      </S.SettingWrapper>
      <DeploymentTypeChangeModal
        confirmDeploymentTypeChangeModal={confirmDeploymentTypeChangeModal}
        closeModal={closeModal}
        onChangeDeploymentTypeSave={onChangeDeploymentTypeSave}
        cancel={cancel}
      />
    </>
  );
};

export default DeploymentTypeSetting;
